import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import Home from './pages/Home';
import BlogPost from './components/BlogPost';
import Daily from './pages/Daily';
import DesignExplore from './pages/DesignExplore';
import VisualExplore from './pages/VisualExplore';
import Select from './pages/Select';
import NotFound from './components/NotFound';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <div className="min-h-screen transition-colors duration-300">
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<Home />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                <Route path="/daily" element={<Daily />} />
                <Route path="/design-explore" element={<DesignExplore />} />
                <Route path="/visual-explore" element={<VisualExplore />} />
                <Route path="/select" element={<Select />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AnimatePresence>
          </div>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
